import { MultiplierService } from 'core/api/services/multiplier';
import { GetMultipliersFunction } from './getMultipliers.type';

const getMultipliers: GetMultipliersFunction = async ({
  payload,
  onInit,
  onSuccess,
  onError,
  onFinally,
}) => {
  if (!!onInit) onInit();
  try {
    const states = await MultiplierService.getMultipliers(payload);

    if (!!onSuccess) onSuccess(states);

    return states;
  } catch (error) {
    console.error(error);

    if (!!onError) onError(error);

    return [];
  } finally {
    if (!!onFinally) onFinally();
  }
};

export default getMultipliers;
